<template>
	<div>
		<h1 v-if="article.title" class="text-3xl mb-4" v-html="article.title"></h1>
		<h2 v-if="article.subtitle" class="text-2xl mb-4" v-html="article.subtitle"></h2>
		<div
      v-if="article.content"
      class="wysiwyg-content"
      v-html="article.content"
    ></div>
	</div>
</template>

<script setup>
defineProps({
  article: {
    type: Object,
    required: true
  }
})
</script>
